import { useDeepCompareEffectNoCheck } from 'use-deep-compare-effect';

import {
  FeedbackToastDataProperties,
  FeedbackToastInteractionCloseProperties,
  FeedbackToastInteractionCommentProperties,
  FeedbackToastInteractionRatingProperties,
  FeedbackToastInteractionSubmitProperties,
  OperationTypeValueType,
  feedbackToastData,
  feedbackToastInteractionClose,
  feedbackToastInteractionComment,
  feedbackToastInteractionRating,
  feedbackToastInteractionSubmit,
  feedbackToastView,
} from 'root/telemetry/avo/Avo';

export type OperationType = OperationTypeValueType;

export function useTelemetryFeedbackToastView(
  operationType: OperationType,
  warehouseId: string,
  disabled?: boolean,
) {
  useDeepCompareEffectNoCheck(() => {
    if (disabled) return;
    const viewTimestamp = Date.now();
    return () => {
      const durationMs = Date.now() - viewTimestamp;
      feedbackToastView({ operationType, wmVenueId: warehouseId, durationMs });
    };
  }, [disabled, operationType, warehouseId]);
}

export function telemetryFeedbackToastInteractionClose(
  properties: FeedbackToastInteractionCloseProperties,
) {
  return feedbackToastInteractionClose(properties);
}

export function telemetryFeedbackToastInteractionRating(
  properties: FeedbackToastInteractionRatingProperties,
) {
  return feedbackToastInteractionRating(properties);
}

export function telemetryFeedbackToastInteractionComment(
  properties: FeedbackToastInteractionCommentProperties,
) {
  return feedbackToastInteractionComment(properties);
}

export function telemetryFeedbackToastInteractionSubmit(
  properties: FeedbackToastInteractionSubmitProperties,
) {
  return feedbackToastInteractionSubmit(properties);
}

export function telemetryFeedbackToastData(properties: FeedbackToastDataProperties) {
  return feedbackToastData(properties);
}
